<div class="thread-entity-type" [style.background]="type | threadEntityTypeColor">
  {{ type | threadEntityTypeLabel }}
</div>
